import { AxiosResponse, AxiosError } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TZyomuinUnkoGeppo2SummaryListGetReq,
  TZyomuinUnkoGeppo2ListGetReq,
  TZyomuinUnkoGeppo2SummaryListGetRes,
  TZyomuinUnkoGeppo2ListGetRes,
  TZyomuinUnkoGeppo2PrintReq,
  TZyomuinUnkoGeppo2CreateReq,
  TZyomuinUnkoGeppo2TeatePutReq,
} from "./TZyomuinUnkoGeppoV2"

/**
 * 乗務員運行月報に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class ZyomuinUnkoGeppoV2Service extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TZyomuinUnkoGeppo2SummaryListGetReq} params
   * @param {(param: TApiResponse<TZyomuinUnkoGeppo2SummaryListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TZyomuinUnkoGeppo2SummaryListGetRes[]>) => any} reject
   * @memberof MenuService
   */
  getSummaryList = async (params: TZyomuinUnkoGeppo2SummaryListGetReq) => {
    try {
      const res: AxiosResponse<
        TApiResponse<TZyomuinUnkoGeppo2SummaryListGetRes>
      > = await this.getInner(
        `/driverpayroll/zyomuinunkogepposummaryv2`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 乗務員運行月報 取得
   *
   * @param {TZyomuinUnkoGeppo2ListGetReq} params
   * @param {(param: TApiResponse<TZyomuinUnkoGeppo2ListGetRes、[]>) => any} resolve
   * @param {(param: TApiResponse<TZyomuinUnkoGeppo2ListGetRes、[]>) => any} reject
   * @memberof MenuService
   */
  getList = async (params: TZyomuinUnkoGeppo2ListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinUnkoGeppo2ListGetRes[]>> =
        await this.getInner(`/driverpayroll/zyomuinunkogeppov2`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 乗務員運行月報 帳票作成
   *
   * @param {TZyomuinUnkoGeppo2PrintReq} params
   * @memberof ZyomuinUnkoGeppo2Service
   */
  printZyomuinUnkoGeppo2 = async (
    params: TZyomuinUnkoGeppo2PrintReq,
    resolve?: (param: TApiResponse<Blob>) => any,
    reject?: (param: AxiosError<TApiResponse<Blob>>) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<Blob> = await this.postInner(
        `/report/CreateReport/G110102_2`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 乗務員運行月報 集計実行
   *
   * @param {TZyomuinUnkoGeppo2CreateReq} params
   * @memberof ZyomuinUnkoGeppo2Service
   */
  calcZyomuinUnkoGeppo2 = async (
    params: TZyomuinUnkoGeppo2CreateReq,
    resolve?: (param: TApiResponse<boolean>) => any,
    reject?: (param: AxiosError<TApiResponse<boolean>>) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<boolean> = await this.postInner(
        `/driverpayroll/zyomuinunkogeppov2/actions/create`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 乗務員運行月報 手当更新 V2
   *
   * @param {TZyomuinUnkoGeppo2TeatePutReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof ZyomuinUnkoGeppo2Service
   */
  putTeate = async (id: string, data: TZyomuinUnkoGeppo2TeatePutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/driverpayroll/zyomuinunkogeppov2/actions/updateteate/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
